import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomerServices from '../../services/CustomerServices';

const initialState = {
	claims: [],
	claimsArr: [],
	loading: false,
	error: null,
	errorMessage: null,
	isSuccess: false,
	listCategories: [],
	allCompaniesList: [],
	listProducts: [],
	allCompanies: [],
	listOrders: [],
	bills: [],
	orderDetails: {},
	basket: [],
	checkedList: [],
	totalQty: 0,
	basketTotalQty: 0,
	total: 0,
	companyDetails: null,
	factures: [],
	factureDetails: {},
	allContenaires: [], // ← new
};

// ==================== AUTHENTICATION ====================
export const registerClient = createAsyncThunk(
	'customer/registerClient',
	async (userData, { rejectWithValue }) => {
		try {
			const res = await CustomerServices.registerClient(userData);
			return res.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

// ==================== FACTURES ====================
export const getFacturesByCustomer = createAsyncThunk(
	`/getFacturesByCustomer`,
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await CustomerServices.getFacturesByCustomer(token, page, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getFactureByIdCustomer = createAsyncThunk(
	`/getFactureByIdCustomer`,
	async ({ token, id }, thunkApi) => {
		try {
			const res = await CustomerServices.getFactureById(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== COMPANIES ====================
export const getAllCompanies = createAsyncThunk(
	'customer/getAllCompanies',
	async ({ token }, thunkApi) => {
		try {
			const res = await CustomerServices.getAllCompanies(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	}
);

export const getCompanyByIdClient = createAsyncThunk(
	'customer/getCompanyByIdClient',
	async ({ token, id }, thunkApi) => {
		try {
			const res = await CustomerServices.getCompanyByIdClient(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	}
);

// ==================== PROFILE ====================
export const updateCustomerProfile = createAsyncThunk(
	'/update_profile_customer',
	async ({ token, data }, thunkApi) => {
		try {
			const res = await CustomerServices.updateCustomerProfile(token, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const updateCustomerPassword = createAsyncThunk(
	'/update_profile_password_customer',
	async ({ token, data }, thunkApi) => {
		try {
			const res = await CustomerServices.updateCustomerPassword(token, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== CATEGORIES & PRODUCTS ====================
export const getCustomerCategories = createAsyncThunk(
	'/get_categories_customer',
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await CustomerServices.getCustomerCategories(token, page, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getListCategoriesProducts = createAsyncThunk(
	'/getListCategoriesProducts',
	async ({ token }, thunkApi) => {
		try {
			const res = await CustomerServices.getListCategoriesProducts(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getCustomerProductsList = createAsyncThunk(
	'/get_products_customer',
	async ({ token, page, search, categories, companyId }, thunkApi) => {
		try {
			const res = await CustomerServices.getCustomerProductsList(token, page, search, categories, companyId);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== BASKET ====================
export const addBasket = createAsyncThunk('/add_basket', async ({ token, data }, thunkApi) => {
	try {
		const res = await CustomerServices.addBasket(token, data);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const getBasket = createAsyncThunk('/get_basket', async ({ token, id }, thunkApi) => {
	try {
		const res = await CustomerServices.getBasket(token, id);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const deleteBasket = createAsyncThunk('/delete_basket', async ({ token, id }, thunkApi) => {
	try {
		const res = await CustomerServices.deleteBasket(token, id);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const udpateStockProduitBasket = createAsyncThunk(
	'/update_stock_basket',
	async ({ token, id, data }, thunkApi) => {
		try {
			const res = await CustomerServices.udpateStockProduitBasket(token, id, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const clearBasket = createAsyncThunk('/clear_basket', async ({ token }, thunkApi) => {
	try {
		const res = await CustomerServices.clearBasket(token);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

// ==================== ORDERS ====================
export const addOrderByCustomer = createAsyncThunk(
	'/add_order',
	async ({ token, data }, thunkApi) => {
		try {
			const res = await CustomerServices.addOrderByCustomer(token, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getOrdersByCustomer = createAsyncThunk(
	`/getOrdersByCustomer`,
	async ({ token, page, search, status }, thunkApi) => {
		try {
			const res = await CustomerServices.getOrdersByCustomer(token, page, search, status);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getOrderByIdCustomer = createAsyncThunk(
	`/getOrderByIdCustomer`,
	async ({ token, id }, thunkApi) => {
		try {
			const res = await CustomerServices.getOrderByIdCustomer(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== BILLS ====================
export const getBillsByCustomer = createAsyncThunk(
	`/getBillsByCustomer`,
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await CustomerServices.getBillsByCustomer(token, page, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getBillByIdCustomer = createAsyncThunk(
	`/getBillByIdCustomer`,
	async ({ token, id }, thunkApi) => {
		try {
			const res = await CustomerServices.getBillByIdCustomer(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== CLAIMS ====================
export const ClaimsClientsData = createAsyncThunk(
	`/ClaimsClientsData`,
	async ({ token, page, search }, thunkApi) => {
		try {
			const res = await CustomerServices.ClaimsClientsData(token, page, search);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const CustomerClaimsTypes = createAsyncThunk(
	`/CustomerClaimsTypes`,
	async ({ token }, thunkApi) => {
		try {
			const res = await CustomerServices.CustomerClaimsTypes(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const addCliamsByCustomer = createAsyncThunk(
	`/addCliamsByCustomer`,
	async ({ token, data }, thunkApi) => {
		try {
			const res = await CustomerServices.addCliamsByCustomer(token, data);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const getCliamById = createAsyncThunk(`/getCliamById`, async ({ token, id }, thunkApi) => {
	try {
		const res = await CustomerServices.getCliamById(token, id);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

// ==================== STOCK ====================
export const checkStock = createAsyncThunk(`/checkStock`, async ({ token, list }, thunkApi) => {
	try {
		const res = await CustomerServices.checkStock(token, list);
		return res.data;
	} catch (error) {
		return thunkApi.rejectWithValue(error.response.data);
	}
});

export const clearBasketCustomer = createAsyncThunk(
	`/clearBasketCustomer`,
	async ({ token, id }, thunkApi) => {
		try {
			const res = await CustomerServices.clearBasketCustomer(token, id);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

export const companiesForCustomer = createAsyncThunk(
	'/companiesForCustomer',
	async ({ token }, thunkApi) => {
		try {
			const res = await CustomerServices.getCompaniesForCustomer(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== CONTENAIRES ==================== ← new
export const getAllContenairesList = createAsyncThunk(
	'customer/getAllContenairesList',
	async ({ token }, thunkApi) => {
		try {
			const res = await CustomerServices.getAllContenairesList(token);
			return res.data;
		} catch (error) {
			return thunkApi.rejectWithValue(error.response.data);
		}
	},
);

// ==================== SLICE ====================
const customerSlice = createSlice({
	name: 'customer',
	initialState,
	reducers: {
		handleChangeQuantity: (state, action) => {
			const { productId, newQuantity } = action.payload;
			const itemToUpdate = state.basket.find((item) => item.product._id === productId);
			if (itemToUpdate) {
				state.totalQty += newQuantity - itemToUpdate.quantity;
				itemToUpdate.quantity = newQuantity;
			}
		},
		clearCheckList: (state) => {
			state.checkedList = [];
		},
		setCheckedList: (state, action) => {
			const itemId = action.payload._id;
			if (!state.checkedList.some((item) => item._id === itemId)) {
				state.checkedList.push(action.payload);
			}
		},
		setUnCheckedList: (state, action) => {
			state.checkedList = state.checkedList.filter((el) => el._id !== action.payload._id);
		},
		updatedbasketTotalQty: (state, action) => {
			state.basketTotalQty = action.payload;
		},
		clearCompanyDetails: (state) => {
			state.companyDetails = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(registerClient.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(registerClient.fulfilled, (state) => {
				state.loading = false;
				state.isSuccess = true;
			})
			.addCase(registerClient.rejected, (state, action) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = action.payload?.message || "Erreur lors de l'inscription";
			})
			.addCase(updateCustomerProfile.fulfilled, (state) => {
				state.isSuccess = true;
				state.loading = false;
			})
			.addCase(updateCustomerProfile.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(updateCustomerPassword.fulfilled, (state) => {
				state.isSuccess = true;
				state.loading = false;
			})
			.addCase(updateCustomerPassword.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getCustomerCategories.pending, (state) => {
				state.loading = true;
			})
			.addCase(getCustomerCategories.fulfilled, (state, action) => {
				state.isSuccess = true;
				state.loading = false;
				state.listCategories = action.payload.data;
				state.total = action.payload.total;
			})
			.addCase(getCustomerCategories.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getCustomerProductsList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getCustomerProductsList.fulfilled, (state, action) => {
				state.isSuccess = true;
				state.loading = false;
				state.listProducts = action.payload.data;
				state.total = action.payload.total;
			})
			.addCase(getCustomerProductsList.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getBasket.pending, (state) => {
				state.loading = true;
			})
			.addCase(getBasket.fulfilled, (state, action) => {
				state.basket = action.payload.data || [];
				const totalQty = state.basket.reduce((acc, item) => acc + (item.quantity || 0), 0);
				state.basketTotalQty = isNaN(totalQty) ? 0 : totalQty;
				state.loading = false;
			})
			.addCase(getBasket.rejected, (state, action) => {
				state.error = true;
				state.errorMessage = action.payload?.message;
				state.loading = false;
			})
			.addCase(addBasket.pending, (state) => {
				state.loading = true;
			})
			.addCase(addBasket.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(addBasket.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(udpateStockProduitBasket.pending, (state) => {
				state.loading = true;
			})
			.addCase(udpateStockProduitBasket.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteBasket.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteBasket.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(addOrderByCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(addOrderByCustomer.fulfilled, (state) => {
				state.basket = [];
				state.loading = false;
			})
			.addCase(addOrderByCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getOrdersByCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(getOrdersByCustomer.fulfilled, (state, action) => {
				state.listOrders = action.payload.data || [];
				state.total = action.payload.total;
				state.loading = false;
			})
			.addCase(getOrdersByCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getOrderByIdCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(getOrderByIdCustomer.fulfilled, (state, action) => {
				state.orderDetails = action.payload.data;
				state.loading = false;
			})
			.addCase(getOrderByIdCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(ClaimsClientsData.pending, (state) => {
				state.loading = true;
			})
			.addCase(ClaimsClientsData.fulfilled, (state, action) => {
				state.claimsArr = action.payload.data || [];
				state.total = action.payload.total;
				state.loading = false;
			})
			.addCase(ClaimsClientsData.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getBillsByCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(getBillsByCustomer.fulfilled, (state, action) => {
				state.bills = action.payload.data || [];
				state.total = action.payload.total;
				state.loading = false;
			})
			.addCase(getBillsByCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(companiesForCustomer.pending, (state) => {
				state.loading = true;
				state.error = false;
			})
			.addCase(companiesForCustomer.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.allCompanies = action.payload.data || [];
			})
			.addCase(companiesForCustomer.rejected, (state, action) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = action.payload?.message || 'Erreur lors du chargement des entreprises';
				state.allCompanies = [];
			})
			.addCase(getAllCompanies.pending, (state) => {
				state.loading = true;
				state.error = false;
			})
			.addCase(getAllCompanies.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.allCompaniesList = action.payload.data || [];
				state.total = action.payload.total || 0;
			})
			.addCase(getAllCompanies.rejected, (state, action) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = action.payload?.message || 'Erreur lors du chargement des entreprises';
				state.allCompaniesList = [];
			})
			.addCase(getCompanyByIdClient.pending, (state) => {
				state.loading = true;
				state.error = false;
				state.companyDetails = null;
			})
			.addCase(getCompanyByIdClient.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.companyDetails = action.payload.data;
			})
			.addCase(getCompanyByIdClient.rejected, (state, action) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = action.payload?.message || "Erreur lors du chargement de l'entreprise";
				state.companyDetails = null;
			})
			// ==================== FACTURES ====================
			.addCase(getFacturesByCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(getFacturesByCustomer.fulfilled, (state, action) => {
				state.factures = action.payload.data || [];
				state.total = action.payload.total;
				state.loading = false;
			})
			.addCase(getFacturesByCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			.addCase(getFactureByIdCustomer.pending, (state) => {
				state.loading = true;
			})
			.addCase(getFactureByIdCustomer.fulfilled, (state, action) => {
				state.factureDetails = action.payload;
				state.loading = false;
			})
			.addCase(getFactureByIdCustomer.rejected, (state) => {
				state.loading = false;
				state.error = true;
			})
			// ==================== CONTENAIRES ==================== ← new
			.addCase(getAllContenairesList.pending, (state) => {
				state.loading = true;
				state.error = false;
			})
			.addCase(getAllContenairesList.fulfilled, (state, action) => {
				state.loading = false;
				state.error = false;
				state.allContenaires = action.payload.data || [];
			})
			.addCase(getAllContenairesList.rejected, (state, action) => {
				state.loading = false;
				state.error = true;
				state.errorMessage = action.payload?.message || 'Erreur lors du chargement des contenaires';
				state.allContenaires = [];
			});
	},
});

export default customerSlice.reducer;
export const {
	handleChangeQuantity,
	setCheckedList,
	setUnCheckedList,
	clearCheckList,
	updatedbasketTotalQty,
	clearCompanyDetails,
} = customerSlice.actions;